export default "__VITE_ASSET__BPOHPONX__"